import $ from "jquery";
import bdjs from "@bd-core/bdjs";

export const PhoneScreen = () => {
    const isPhoneScreen = $("#page-phone-screen").length > 0;
    if (!isPhoneScreen) return false;

    bdjs.hideLoading();

    // const onInit = () => {
    //     const tasks = CONFIG.game.tasks;

    //     const $taskList = $(".js-task-list");
    //     const templatedTaskList = $("#task-list").html();
    //     const html = compile(templatedTaskList, { tasks });
    //     $taskList.html(html);
    // };
    // onInit();
    // RoundTimer is already initialized globally in game-logic.js
    // No need to create a separate instance here

    // const $taskItems = $(".mobile__task-item");
    // const $buyGreenEnergy = $(".mobile__btn.green-energy");
    // const $buyFossilEnergy = $(".mobile__btn.fossil-energy");

    // function isVotedBuyEnergy(type) {
    //     const $this = $(this);

    //     if (type === "green") {
    //         $(".js-green-energy-bought").parent(".mobile__menu-options-item").addClass("is-bought");

    //         // this will remove is-bought class after 1.7 seconds only for green energy
    //         setTimeout(() => {
    //             $(".js-green-energy-bought").parent(".mobile__menu-options-item").removeClass("is-bought");
    //         }, 1700);
    //     } else {
    //         $(".js-fossil-energy-bought").parent(".mobile__menu-options-item").addClass("is-bought");

    //         // this will remove is-bought class after 1.7 seconds only for fossil energy
    //         setTimeout(() => {
    //             $(".js-fossil-energy-bought").parent(".mobile__menu-options-item").removeClass("is-bought");
    //         }, 1700);
    //     }

    //     // this will remove is-waiting class after people voted to buy
    //     // $this.parent().removeClass("is-waiting");                
    // }

    // $buyGreenEnergy.on("click", function () {
    //     const $this = $(this);
    //     $this.parent().addClass("is-waiting");
    //     $this.parent().css("pointer-events", "none");

    //     if (isVotedBuyEnergy("green")) {
    //         $this.parent().css("pointer-events", "auto");
    //         return;
    //     }

    //     setTimeout(() => {
    //         $this.parent().removeClass("is-waiting");
    //         $this.parent().css("pointer-events", "auto");
    //     }, 3000);
    // });

    // $buyFossilEnergy.on("click", function () {
    //     const $this = $(this);
    //     $this.parent().addClass("is-waiting");
    //     $this.parent().css("pointer-events", "none");

    //     if (isVotedBuyEnergy("fossil")) {
    //         $this.parent().css("pointer-events", "auto");
    //         return;
    //     }

    //     setTimeout(() => {
    //         $this.parent().removeClass("is-waiting");
    //         $this.parent().css("pointer-events", "auto");
    //     }, 3000);
    // });

    // $taskItems.each(function () {
    //     const $item = $(this);
    //     const $taskList = $item.closest(".mobile__task-list");


    //     $item.on("click", function () {
    //         $item.toggleClass("is-completed");


    //     });
    // });

    // function onRemoveTaskItem() {        
    //     $(".mobile__task-item.is-completed").addClass("is-removed");
    //     $(".mobile__task-item.is-expired").addClass("is-removed");

    //     const $taskList = $(".mobile__task-list");

    //     const addTaskItem = () => {
    //         $taskList.append(`
    //             <div class="mobile__task-item js-task-item">
    //                         <div class="mobile__task-item-inner">
    //                             <div class="mobile__task-item-icon">                                    
    //                                  <img src="/wp-content/themes/kpn/assets/images/ev-car.svg" alt="task icon">
    //                             </div>
    //                             <div class="mobile__task-item-progress">
    //                                 <div class="mobile__task-item-progress-title">
    //                                     EV charging
    //                                 </div>
    //                                 <div class="mobile__task-item-progressBar loading-100">
    //                                     <span></span>
    //                                     <span></span>
    //                                     <span></span>
    //                                     <span></span>
    //                                     <span></span>
    //                                     <span></span>
    //                                     <span></span>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                         <div class="mobile__task-item-weight">
    //                             <img src="/wp-content/themes/kpn/assets/images/lightning.svg" alt="lightning icon">
    //                             High
    //                         </div>

    //                         <div class="mobile__task-item-status completed">
    //                             <img src="/wp-content/themes/kpn/assets/images/checkmark.svg" alt="checkmark icon">
    //                         </div>

    //                         <div class="mobile__task-item-status expired">
    //                             <img src="/wp-content/themes/kpn/assets/images/exclamation.svg" alt="exclamation icon">
    //                         </div>

    //                         <div class="mobile__task-item-warning">
    //                             <img src="/wp-content/themes/kpn/assets/images/exclamation.svg" alt="exclamation icon">
    //                         </div>
    //                     </div>
    //             `);
    //     };

    //     setTimeout(() => {
    //         // add task item as much as the number of task that have class is-removed, 
    //         // THIS IS WRONG CODE because all item with is removed class is counted AND SHOULD BE FIXED. 
    //         // JUST A SIMULATION
    //         for (let i = 0; i < $(".mobile__task-item.is-removed").length; i++) {
    //             addTaskItem();
    //         }
    //     }, 1750);

    // }

    // // simulation of task item removal every 10 seconds
    // setTimeout(onRemoveTaskItem, 10000);
    // setTimeout(onRemoveTaskItem, 20000);
    // setTimeout(onRemoveTaskItem, 30000);
};
